import { configureStore } from '@reduxjs/toolkit';
import { rootReducer } from './reducer/index.js';
// import { persistStore } from 'redux-persist';
import { combineReducers } from 'redux';
import ENVIRONMENT_CONFIG from '@velzon/config/environment.config.js';

const reducers = combineReducers(rootReducer);

const store = configureStore({
  devTools: ENVIRONMENT_CONFIG.REACT_APP_ENVIRONMENT !== 'production',
  // reducer: persistedReducer,
  reducer: reducers,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false
    })
});

// Create a persisted version of the store
// const persister = persistStore(store);

export { store /*persister*/ };